import { createAction, props } from '@ngrx/store';

export const loadConfig = createAction(
	'[Access Control Config] Load Config',
	props<{ data: any }>()
);
